module.exports = __webpack_public_path__ + "static/media/LinkedIn.57425128.svg";